var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modifyBj",on:{"click":_vm.hide}},[_c('img',{staticClass:"img1",attrs:{"src":_vm.imgurl},on:{"click":function($event){$event.stopPropagation();}}})])}
var staticRenderFns = []

export { render, staticRenderFns }